import React, { useEffect, useState } from 'react';
import Button from '../../../../../../components/controls/Button';
import BaseModal from '../../../../../../components/modals/BaseModal';
import { Alert } from '../../../../../../components/visual/Alert/Alert';
import { apiDELETE } from '../../../../../../utils/networking';
import useMessages from '../../../../../../utils/useMessages';

/**
 *
 * @param {{
 *  delegate: import('../../../../../../store/reducers/delegatesReducer').TDelegateListItem;
 *  onSuccess?():void;
 * }} props
 * @returns {JSX.Element} - The rendered DelegateModal component.
 */
export const DelegateModalDeleteInvoker = (props) => {
  const { delegate, onSuccess } = props;
  const [isOpened, setIsOpened] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isBusy, setIsBusy] = useState(false);
  const messages = useMessages();

  const deleteDelegate = async () => {
    setIsBusy(true);
    setErrorMessage('');
    try {
      const resp = await apiDELETE(`/recommendation/rest/evaluatorDelegate/${delegate.id}`);
      if (/^20/.test(resp.status)) {
        onSuccess?.();
        onModalClose();
        messages.clear().notifyGreen('Delegate deleted successfully.');
      } else {
        throw new Error('An error occurred while deleting delegate. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setErrorMessage(
        'An error occurred while deleting delegate. Please try again.'
      );
    } finally {
      setIsBusy(false);
    }
  }

  const modalBody = () => {
    return <>
      <Alert show={!!errorMessage} message={errorMessage} type={'red'} className="mb-2" />
      <p tabIndex={0} className="mb-2">
        You cannot undo this action.<br />
        If you want {delegate.firstName} {delegate.lastName} to be a delegate again, you must re-add them.
      </p>
    </>;
  }

  const modalControls = () => {
    return <>
      <Button
        onClick={onModalClose}
        outline
        primary
        disabled={isBusy}
      >
        Cancel
      </Button>
      <Button
        onClick={deleteDelegate}
        danger
        disabled={isBusy}
        isBusy={isBusy}
      >
        Remove
      </Button>
    </>
  }

  const onModalClose = () => {
    setIsOpened(false);
    setErrorMessage('');
  }

  useEffect(() => {
    return () => {
      onModalClose();
    }
  }, []);

  return <>
    <Button
      link
      danger
      onClick={() => {
        setIsOpened(true);
      }}>
      Delete
    </Button>
    <BaseModal
      size='compact'
      initialFocus={false}
      show={isOpened}
      isBusy={isBusy}
      title={`Remove ${delegate.firstName} ${delegate.lastName} as a Delegate`}
      modalBodyClass={'text-center'}
      closeIcon={true}
      body={modalBody()}
      controls={modalControls()}
      onClose={() => {
        onModalClose?.();
      }}
    />
  </>
}
